/**
 * Created by rhinov20e on 8/26/2016.
 *
 */

declare var cc: any;

export class SafeZoneNode extends cc.DrawNode {
    constructor() {
        // Call parent constructor
        super();

        // Here is the center position
        var center = new cc.p(0, 0);

        // Draw the rotation circle
        this.addCircles(center);

        // Set the name of this node
        this.setName('safeZone');

        // Finally set position, anchor, rotation and visibility
        this.setAnchorPoint(new cc.p(0.5, 0.5));
        this.setPosition(cc.p(0, 0));
        this.setVisible(true);

        this.addLabel(40, new cc.color('#FF0000'), true);
        this.addLabel(45, new cc.color('#FFA500'), false);
        this.addLabel(60, new cc.color('#FFFF00'), true);
    }

     addLabel(radius: number, color: any, top: boolean) {
        var labelSize = new cc.size(0, 13);

        var lengthLabel = new cc.LabelTTF('' + (radius * 2) + "cm", 'Roboto-Light', 10, labelSize, cc.TEXT_ALIGNMENT_CENTER, cc.TEXT_ALIGNMENT_CENTER);

        lengthLabel.setName('TopLabel');
        lengthLabel.setAnchorPoint(new cc.p(0.5, 0.5));
        lengthLabel.setColor(color);
        if (top) {
            lengthLabel.setPosition(0, radius - 8);
        }
        else {
            lengthLabel.setPosition(0, -radius - 8);
        }
        this.addChild(lengthLabel);
    }

    // Add the rotation circle to the node to show the entity node (instanciating this node) can be rotated
    addCircles(center: any) {
        // Draw the rotation circle
        this.drawCircle(center, 40, Math.PI * 2, 100, false, 2, new cc.color('#FF0000'));
        this.drawCircle(center, 45, Math.PI * 2, 100, false, 2, new cc.color('#FFA500'));
        this.drawCircle(center, 60, Math.PI * 2, 100, false, 2, new cc.color('#FFFF00'));
    }
}
